// const documentLanguage = 'it';
const documentLanguage = document.documentElement.lang;
console.log('lang da drupal', documentLanguage);

let currentLanguage = documentLanguage; // Valore predefinito

export const getLanguage = () => currentLanguage;

export const setLanguage = (lang: string) => {
  currentLanguage = lang;
};
